export class SupportMessages {
    public static readonly CONTACT_SUPPORT_MESSAGE = `If you are experiencing technical problems with Via,
   please call or email our technical support team.`;
    public static readonly FEEDBACK_SUCCESS = 'Your message was sent successfully!';
    public static readonly FEEDBACK_ERROR = 'Error! There was a problem sending your message, please try again.';
}

export class SupportEmails {
    public static readonly TECHNICAL_SUPPORT_EMAIL = 'Via.Support@Euromonitor.com';
    public static readonly DATA_QUERY_EMAIL = 'Via.DS@Euromonitor.com';
    public static readonly OTHER_QUERY_EMAIL = 'Via.Contact@Euromonitor.com';
    public static readonly PORTAL_ADMIN_EMAIL = 'portaladmin@via.com';
}

export class FeedbackTopics {
    public static readonly ACCOUNT_MANAGER_QUERY = 'Account Manager Query';
    public static readonly TECHNICAL_SUPPORT = 'Technical Support';
    public static readonly DATA_QUERY = 'Data Query';
    public static readonly OTHER_QUERY = 'Other (Please specify in your message)';
}
